import { patchState, signalStore, withMethods, withState } from '@ngrx/signals'
import { StateApp } from '@shared/models/appFlow'
import type { PushNotificationSchema } from '@capacitor/push-notifications'

interface GlobalStoreState {
  appState: StateApp
  lastNotification: PushNotificationSchema | undefined
}
const initialState: GlobalStoreState = {
  appState: {
    accountId: '',
    stateId: '',
    description: '',
    actions: [],
    userLevel: {
      id: '',
      name: '',
      level: -1,
    },
    loanProductType: undefined,
    accounts: [],
    tags: [],
  },
  lastNotification: undefined,
}

export const GlobalStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(store => ({
    setAppState: (appState: StateApp) => {
      patchState(store, {
        appState,
      })
    },
    setLastNotification: (notification: PushNotificationSchema | undefined) => {
      patchState(store, {
        lastNotification: notification,
      })
    },
  })),
)
